import { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { BlogStudio } from '../components/blog/BlogStudio';
import { SeoInsights } from '../components/blog/SeoInsights';
import { AiVisibilityCard, CitabilityCard, CoverBatchCard, CoverGalleryCard } from '../components/blog/GeoTools';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowLeft, PenLine } from 'lucide-react';

export default function BlogStudioPage() {
    const { language } = useLanguage();
    const navigate = useNavigate();
    const de = language === 'de';
    const [presetTopic, setPresetTopic] = useState('');

    return (
        <div className="p-4 lg:p-8 pb-24 lg:pb-8" data-testid="blog-studio-page" style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 1rem)' }}>
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-2xl mx-auto space-y-4">
                <div className="flex items-center justify-between gap-2">
                    <h1 className="font-display text-xl font-bold flex items-center gap-2">
                        <PenLine className="w-5 h-5 text-violet-600" />
                        {de ? 'Blog-Studio' : 'Blog Studio'}
                    </h1>
                    <Link to="/blog">
                        <Button variant="outline" size="sm" className="rounded-full h-9 px-4 gap-1" data-testid="blog-studio-back-btn">
                            <ArrowLeft className="w-4 h-4" />
                            Blog
                        </Button>
                    </Link>
                </div>
                <BlogStudio onPublished={() => navigate('/blog')} presetTopic={presetTopic} />
                <SeoInsights onUseTopic={(t) => {
                    setPresetTopic(t);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }} />
                <AiVisibilityCard />
                <CitabilityCard />
                <CoverBatchCard />
                <CoverGalleryCard />
            </motion.div>
        </div>
    );
}
